import type { ProjectField, FieldValue } from '../types';

export const mockProjectFields: ProjectField[] = [
  {
    id: 'field-1',
    projectId: 'project-1',
    name: 'Lista de usuarios',
    fieldType: 'Users',
    required: false,
    typeConfig: null,
    description: 'Usuarios asignados al elemento',
    defaultValue: null,
    options: null,
    order: 0,
    createdAt: '2025-01-10T09:00:00Z',
  },
  {
    id: 'field-2',
    projectId: 'project-1',
    name: 'Precio',
    fieldType: 'Number',
    required: false,
    typeConfig: JSON.stringify({ min: 0, decimals: 2 }),
    description: 'Costo estimado',
    defaultValue: null,
    options: null,
    order: 1,
    createdAt: '2025-01-12T11:30:00Z',
  },
  {
    id: 'field-3',
    projectId: 'project-1',
    name: 'Estado de revisión',
    fieldType: 'Select',
    required: true,
    typeConfig: null,
    description: null,
    defaultValue: null,
    options: [
      { id: 'opt-1', name: 'Pendiente', value: 'pending', color: 'yellow', orderIndex: 0 },
      { id: 'opt-2', name: 'En revisión', value: 'reviewing', color: 'indigo', orderIndex: 1 },
      { id: 'opt-3', name: 'Aprobado', value: 'approved', color: 'teal', orderIndex: 2 },
    ],
    order: 2,
    createdAt: '2025-02-01T08:00:00Z',
  },
  {
    id: 'field-4',
    projectId: 'project-1',
    name: 'Correo del contacto',
    fieldType: 'Email',
    required: false,
    typeConfig: null,
    description: null,
    defaultValue: null,
    options: null,
    order: 3,
    createdAt: '2025-02-10T08:00:00Z',
  },
  {
    id: 'field-5',
    projectId: 'project-1',
    name: 'Valor del contrato',
    fieldType: 'Currency',
    required: false,
    typeConfig: JSON.stringify({ currency: 'MXN' }),
    description: null,
    defaultValue: null,
    options: null,
    order: 4,
    createdAt: '2025-02-11T08:00:00Z',
  },
  {
    id: 'field-6',
    projectId: 'project-1',
    name: 'Contrato firmado',
    fieldType: 'Files',
    required: false,
    typeConfig: null,
    description: null,
    defaultValue: null,
    options: null,
    order: 5,
    createdAt: '2025-02-12T08:00:00Z',
  },
];

export const mockFieldValues: FieldValue[] = [
  {
    id: 'val-1',
    taskId: 'task-1',
    fieldId: 'field-2',
    value: '1500',
    updatedAt: '2025-03-15T14:00:00Z',
  },
  {
    id: 'val-2',
    taskId: 'task-1',
    fieldId: 'field-3',
    value: 'reviewing',
    updatedAt: '2025-03-16T09:00:00Z',
  },
  {
    id: 'val-3',
    taskId: 'task-1',
    fieldId: 'field-4',
    value: 'contacto@innovaforce.com',
    updatedAt: '2025-03-17T09:00:00Z',
  },
  {
    id: 'val-4',
    taskId: 'task-1',
    fieldId: 'field-6',
    value: JSON.stringify({
      storageKey: 'customfields/files/contract-2025.pdf',
      fileName: 'contract-2025.pdf',
      mimeType: 'application/pdf',
      fileSize: 204800,
    }),
    updatedAt: '2025-03-18T09:00:00Z',
  },
];
